/**
*  UI-REFACTORED
*    FROM --> ./legacy-web/src/main/js/js/aa/requestFlightMiles/directives/autoCompleteDirective.js
*    TO   --> ./legacy-web/src/main/assets/js/request-flight-miles/directives/auto-complete-directive.js
**/

var RFM_APP = angular.module("RFM_APP");

RFM_APP.directive("airportAutoComplete", ["$timeout", function ($timeout) {
    return {
        restrict: "A",
        link: function (scope, elem, attrs) {
            $timeout(function () {
                RFM_APP.requestMiles.initAutoComplete("#" + attrs.id);
            }, 0);
        }
    };
}]);